import { useId } from 'react'
import { CheckboxProps } from './props.js'
import { CheckIcon } from './icons.js'

export function Checkbox({
  checked,
  onChange,
  label,
  supportingText,
  disabled = false,
  className = '',
}: CheckboxProps) {
  const id = useId()

  const containerClasses = [
    'inline-flex items-start gap-3',
    disabled && 'opacity-38',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  // Visually replace the native checkbox with a h-4 w-4 rounded-sm box
  const checkboxClasses = [
    'flex-shrink-0 w-4 h-4 mt-0.5',
    'rounded-sm border border-outline-variant',
    'interactive transition-colors',
    checked && 'bg-primary border-primary',
    'flex items-center justify-center',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={containerClasses}>
      <label className="flex items-start gap-3 flex-1 cursor-pointer">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          className="sr-only"
        />
        <div className={checkboxClasses}>
          {checked && (
            <CheckIcon className="w-3 h-3 text-on-primary" />
          )}
        </div>
        {label && (
          <div className="flex-1">
            <div className="text-body-md text-on-surface">{label}</div>
            {supportingText && (
              <div className="text-body-sm text-on-surface-variant">
                {supportingText}
              </div>
            )}
          </div>
        )}
      </label>
    </div>
  )
}
